import React from 'react'
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaWhatsapp, FaInstagram, FaTelegramPlane } from "react-icons/fa";
import contactImg from "../../assets/images/contact/contactImg.png";
import { SiSitepoint } from "react-icons/si";
import { useTranslation } from 'react-i18next';

const ContactLeft = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-designColor">{t("contact.box.name")}</h3>
        <p className="text-lg font-normal text-gray-400">
          {t("contact.box.job")}
        </p>
        <div className="space-y-4" style={{ borderTop: '1px solid white', paddingTop: '10px' }}>
          <h3 className="text-2xl font-bold text-gray-100">
            {t("contact.box.letBuild")}
          </h3>

          <p className="text-base text-gray-400 tracking-wide">
            {t("contact.box.wI_CanDo")}
          </p>

          <div className="mt-4">
            <h4 className="text-lg font-semibold text-gray-200 mb-2">
              {t("contact.box.dontMiss")}
            </h4>

            <ul className="space-y-3 text-gray-400">
              <li className="flex items-center gap-2">
                <SiSitepoint className='text-designColor contact-point' />
                <span style={{ flex: '1' }}>{t("contact.box.items.item1")}</span>
              </li>
              <li className="flex items-center gap-2">
                <SiSitepoint className='text-designColor contact-point' />
                <span style={{ flex: '1' }}>{t("contact.box.items.item2")}</span>
              </li>
              <li className="flex items-center gap-2">
                <SiSitepoint className='text-designColor contact-point' />
                <span style={{ flex: '1' }}>{t("contact.box.items.item3")}</span>
              </li>
              <li className="flex items-center gap-2">
                <SiSitepoint className='text-designColor contact-point' />
                <span style={{ flex: '1' }}>{t("contact.box.items.item4")}</span>
              </li>
              <li className="flex items-center gap-2">
                <SiSitepoint className='text-designColor contact-point' />
                <span style={{ flex: '1' }}>{t("contact.box.items.item5")}</span>
              </li>
            </ul>
          </div>
        </div>
        <p className="text-base text-gray-400 flex items-center gap-2">
          {t("contact.box.phone")}: <span className="text-lightText" style={{ direction: 'ltr' }}>+963 968577071</span>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          {t("contact.box.email")}: <span className="text-lightText">business@moayadismail.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">{t("contact.box.findMe")}</h2>
        <div className="flex gap-4">
          <a
            href="https://wa.me/968577071"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaWhatsapp />
          </a>

          <a
            href="https://www.facebook.com/moayad.ismail.524/"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaFacebookF />
          </a>

          <a
            href="https://www.instagram.com/moayad.ismail.99/"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaInstagram />
          </a>

          <a
            href="https://t.me/MoayadIsmail99"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaTelegramPlane />
          </a>

        </div>
      </div>
    </div>
  );
}

export default ContactLeft